/* @flow */

export type TimeoutPollerOptions<T> = {
  fetchStatus: () => Promise<T>,
  isFinished: (status: T) => boolean,
  onUpdate: (status: T) => void,
  onError: (error: Error) => void,
  intervalMs?: number,
  setTimeoutFn?: (fn: () => void, ms: number) => *,
  clearTimeoutFn?: (id: *) => void,
};

const DEFAULT_INTERVAL_MS = 5000;

export default class TimeoutPoller<T> {
  fetchStatus: () => Promise<T>;

  isFinished: (status: T) => boolean;

  onUpdate: (status: T) => void;

  onError: (error: Error) => void;

  intervalMs: number;

  setTimeoutFn: (fn: () => void, ms: number) => *;

  clearTimeoutFn: (id: *) => void;

  timer: * = null;

  constructor(options: TimeoutPollerOptions<T>) {
    this.fetchStatus = options.fetchStatus;
    this.isFinished = options.isFinished;
    this.onUpdate = options.onUpdate;
    this.onError = options.onError;
    this.intervalMs = options.intervalMs ?? DEFAULT_INTERVAL_MS;
    this.setTimeoutFn = options.setTimeoutFn ?? ((fn, ms) => setTimeout(fn, ms));
    this.clearTimeoutFn = options.clearTimeoutFn ?? (id => clearTimeout(id));
  }

  start(): void {
    this.stop();
    this.tick();
  }

  tick = (): void => {
    this.fetchStatus()
      .then(status => {
        this.onUpdate(status);

        if (!this.isFinished(status)) {
          this.scheduleNextTick();
        }
      })
      .catch(err => {
        this.onError(err);
        this.scheduleNextTick();
      });
  };

  scheduleNextTick(): void {
    this.timer = this.setTimeoutFn(this.tick, this.intervalMs);
  }

  stop(): void {
    if (this.timer) {
      this.clearTimeoutFn(this.timer);
      this.timer = null;
    }
  }
}
